import React, { useEffect, lazy, Suspense } from "react";
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate,
  useLocation,
} from "react-router-dom";
import { getCurrentUser } from "../redux/auth/index";
import { useSelector, useDispatch } from "react-redux";

// Lazy loading fallback
import Loading from "../components/Loading/index";
import LogActivity from "./logActvity.js";

// Lazy load components
const Dashboard = lazy(() => import("../components/dashboard/index"));
const SignIn = lazy(() => import("../views/signin/index"));
const AccountVerification = lazy(
  () => import("../views/account-verification/index"),
);
const NotFound = lazy(() => import("../views/404/notfound.js"));
const ForgotPassword = lazy(() => import("../views/forgot-password/index.js"));
const PasswordReset = lazy(() => import("../views/password-reset/index"));
const SignOut = lazy(() => import("../views/signout/index"));
const OtpVerification = lazy(() => import("../views/otp-verification/index"));
import AuthVerify from "./auth-verify.js";

// Component to redirect unauthenticated users to sign-in while preserving intended destination
function NavigateToSignIn() {
  const location = useLocation();
  return (
    <Navigate
      to="/sign-in"
      state={{ from: location.pathname + location.search }}
      replace
    />
  );
}

function RoutesNew() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCurrentUser());
  }, [dispatch]);

  const auth = useSelector((state) => state.auth);
  const isAuthenticated = auth?.authenticated || false;
  if (auth.authLoading) return <Loading />;
  return (
    <BrowserRouter>
      <LogActivity />
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route
            path="/sign-in"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <SignIn />
              )
            }
          />
          <Route
            path="/forgot-password"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <ForgotPassword />
              )
            }
          />
          <Route
            path="/password-reset"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <PasswordReset />
              )
            }
          />
          <Route
            path="/reset-password"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <PasswordReset />
              )
            }
          />
          <Route
            path="/"
            element={isAuthenticated ? <Dashboard /> : <SignIn />}
          />
          <Route
            path="/otp-verification"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <OtpVerification />
              )
            }
          />

          <Route
            path="/account-verification"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <AccountVerification />
              )
            }
          />

          <Route path="/sign-out" element={<SignOut />} />
          <Route
            path="/dashboard/*"
            element={
              isAuthenticated ? (
                <>
                  <AuthVerify />
                  <Dashboard />
                </>
              ) : (
                <NavigateToSignIn />
              )
            }
          />

          {/* Route the rest paths to 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default RoutesNew;
